<template>
<div>
    <sidebar-item :link="{ name: 'FINANCEIRO', icon: 'fas fa-cash-register text-info' }">
        <sidebar-item v-if="permissoes.faturamentoRead" :link="{ name: 'FATURAMENTO', path: '/financeiro/faturamento', icon: 'fas fa-search-dollar'}" />
    </sidebar-item>
</div>
</template>

<script>
export default {
    name: 'SidebarFinanceiro',
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
}
</script>

